import React from 'react';
export function Footer() {
  const scrollToProduct = () => {
    document.getElementById('producto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      {/* Emotional CTA Section */}
      <section className="bg-[#1A1A1A] py-8 px-4" data-id="element-72">
        <div className="max-w-xl mx-auto text-center" data-id="element-73">
          {/* Emotional Heading */}
          <h2 className="text-xl md:text-2xl font-bold mb-3 leading-snug" data-id="element-74">
            <span className="text-white" data-id="element-75">
              Tu primera venta no te cambia solo el bolsillo...
            </span>
            <br data-id="element-76" />
            <span className="text-[#D6006E]" data-id="element-77">te cambia la cabeza.</span>
          </h2>

          {/* Subheading */}
          <p className="text-[#EDEDED] text-sm md:text-base mb-5 leading-relaxed max-w-md mx-auto" data-id="element-78">
            Porque después de esa primera venta, ya no eres una "mujer que
            quiere". Eres una mujer que{' '}
            <span className="font-bold" data-id="element-79">puede.</span>
          </p>

          {/* CTA Button */}
          <button onClick={scrollToProduct} className="bg-[#D6006E] hover:bg-[#B8005C] text-white font-bold text-base md:text-lg py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5 w-full max-w-sm" data-id="element-80">
            Descargar Mujer Digital 3.0 ahora
          </button>
        </div>
      </section>

      {/* Legal Footer */}
      <footer className="bg-black py-5 px-4" data-id="element-81">
        <div className="max-w-xl mx-auto text-center space-y-1.5" data-id="element-82">
          <p className="text-[#B3B3B3] text-xs" data-id="element-83">
            © 2026 Mujer Digital 3.0. Todos los derechos reservados.
          </p>
          <p className="text-[#B3B3B3] text-xs leading-relaxed" data-id="element-84">
            Este sitio web no pertenece a Facebook ni está respaldado por Meta
            Platforms Inc. Facebook es una marca registrada de Meta Platforms,
            Inc.
          </p>
        </div>
      </footer>
    </>;
}